import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=cbd6f078&scoped=true&"
import script from "./RightSideBar.vue?vue&type=script&lang=ts&"
export * from "./RightSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6f078",
  null
  
)

export default component.exports